import { TimeService } from '@festina/collcalc-general-types/collcalc-test/services/TimeService'
import { useFestinaMutation } from '@festina-life/authentication'
import type { Except } from '@festina-life/core'

const method = TimeService.timeServicePostSetTime
type MethodParam = Parameters<typeof method>[0]

export const useSubmitLegalCollCalcTime = () =>
  useFestinaMutation({
    component: 'collCalc',
    isScenario: false,
    roles: TimeService.timeServicePostSetTime_roles,
    mutateFunction: async (arg: Except<MethodParam, 'xTenantId'>) =>
      await method({ ...arg }),
  })
